import { Outlet } from 'react-router-dom';

export default function Contacts() {
  return (
    <Outlet />
  )
}
